import type { Film } from "@/types";

export const films: Film[] = [
  {
    id: "xinghe-bian",
    title: "星河彼岸",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%20of%20a%20lone%20astronaut%20silhouette%20standing%20before%20a%20vast%20glowing%20nebula%20and%20a%20distant%20ringed%20planet%2C%20deep%20navy%20and%20teal%20palette%20with%20a%20warm%20orange%20rim%20light%2C%20moody%20dramatic%20lighting%2C%20atmospheric%20depth%2C%20minimal%20clean%20composition%2C%20fine%20film%20grain%2C%20no%20text%2C%20premium%20promotional%20artwork&width=600&height=800&seq=film-cover-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20landscape%20of%20a%20glowing%20purple%20and%20teal%20nebula%20over%20a%20dark%20planet%20horizon%20with%20a%20distant%20spacecraft%20silhouette%2C%20deep%20navy%20tones%20with%20orange%20accent%20light%2C%20moody%20atmospheric%20depth%2C%20epic%20film%20still%2C%20no%20text&width=1600&height=900&seq=film-bd-01&orientation=landscape",
    category: "电影",
    genres: ["科幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    popularity: 9820,
    director: "陈砺行",
    actors: ["林致远", "苏晚晴", "周航"],
    summary:
      "一场跨越二十年的深空远征，宇航员陆行舟在失联的探测任务中发现了一段被刻意隐藏的坐标。为了找回失踪的搭档，他独自驶入从未有人抵达的星河彼岸，也驶向自己内心最深的孤独。",
    highlights: [
      "全程 IMAX 实拍，星云与宇宙场景视觉震撼",
      "以硬科幻外壳包裹柔软的情感内核",
      "配乐由国际交响乐团录制，声场层次丰富",
    ],
    tags: ["科幻", "太空", "孤独", "视觉大片"],
    releaseDate: "2024-07-19",
  },
  {
    id: "wusheng-zhicheng",
    title: "无声之城",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20movie%20poster%20key%20art%20of%20a%20rain%20soaked%20empty%20city%20street%20at%20night%20with%20a%20single%20silhouetted%20figure%20walking%20under%20dim%20streetlights%2C%20cold%20gray%20and%20deep%20blue%20palette%20with%20a%20faint%20amber%20glow%2C%20moody%20dramatic%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20thriller%20promotional%20artwork&width=600&height=800&seq=film-cover-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20moody%20film%20still%20of%20an%20empty%20rainy%20city%20street%20at%20night%20reflecting%20neon%20signs%20on%20wet%20asphalt%2C%20cold%20blue%20and%20gray%20tones%20with%20amber%20highlights%2C%20cinematic%20depth%20of%20field%2C%20no%20text&width=1600&height=900&seq=film-bd-02&orientation=landscape",
    category: "电影",
    genres: ["悬疑", "犯罪", "惊悚"],
    region: "中国大陆",
    year: 2023,
    rating: 8.4,
    popularity: 7610,
    director: "赵启明",
    actors: ["方既明", "何静姝", "梁一鸣"],
    summary:
      "整座城市的声音在一夜之间消失了，只有刑侦顾问简宁还能听到别人听不见的低语。她必须在真相被彻底掩埋之前，解开一桩跨越十年的连环谜案。",
    highlights: [
      "声音设计的教科书级示范，静默与噪音形成强烈对比",
      "非线性叙事层层反转，结局出人意料",
      "冷峻镜头语言营造高压氛围",
    ],
    tags: ["悬疑", "犯罪", "反转", "犯罪片"],
    releaseDate: "2023-11-03",
  },
  {
    id: "xiari-huisheng",
    title: "夏日回声",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20key%20art%20of%20two%20young%20people%20sitting%20on%20a%20seaside%20pier%20at%20golden%20hour%2C%20warm%20peach%20and%20soft%20orange%20sunset%20palette%20with%20gentle%20teal%20sea%2C%20dreamy%20lens%20flare%2C%20nostalgic%20airy%20mood%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20film%20promotional%20artwork&width=600&height=800&seq=film-cover-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20summer%20seaside%20scene%20at%20golden%20hour%20with%20warm%20peach%20and%20orange%20sunset%20light%20over%20calm%20turquoise%20water%2C%20dreamy%20nostalgic%20atmosphere%2C%20soft%20lens%20flare%2C%20romantic%20film%20still%2C%20no%20text&width=1600&height=900&seq=film-bd-03&orientation=landscape",
    category: "电影",
    genres: ["爱情", "剧情", "青春"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    popularity: 6480,
    director: "沈知微",
    actors: ["夏知秋", "顾南川", "林小满"],
    summary:
      "十八岁那年的夏天，录音师学徒江予在一盘旧磁带里听到了十五年前的自己。她循着声音回到海边小城，试图还原一段被时间冲淡的初恋。",
    highlights: [
      "温暖治愈的色调与自然光摄影",
      "以声音为线索的浪漫叙事结构",
      "海边小城取景，夏日氛围扑面而来",
    ],
    tags: ["爱情", "青春", "治愈", "夏日"],
    releaseDate: "2024-06-28",
  },
  {
    id: "shanhai-lieren",
    title: "山海猎人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20key%20art%20of%20a%20rugged%20hunter%20standing%20on%20a%20cliff%20overlooking%20vast%20misty%20mountains%20during%20a%20storm%2C%20deep%20forest%20green%20and%20stone%20gray%20palette%20with%20orange%20lightning%20accents%2C%20epic%20dramatic%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20adventure%20film%20artwork&width=600&height=800&seq=film-cover-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20epic%20film%20still%20of%20towering%20misty%20mountain%20peaks%20during%20a%20dramatic%20storm%20with%20lightning%20in%20the%20distance%2C%20deep%20forest%20green%20and%20stone%20gray%20tones%20with%20orange%20accents%2C%20cinematic%20adventure%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-04&orientation=landscape",
    category: "电影",
    genres: ["冒险", "奇幻", "动作"],
    region: "中国大陆",
    year: 2022,
    rating: 7.8,
    popularity: 5890,
    director: "郭行舟",
    actors: ["燕北辰", "白鹿鸣", "程砚"],
    summary:
      "古老的《山海志》记载着九座会移动的灵山。猎人燕北辰为救回被山神掳走的妹妹，踏入只有勇者才能生还的山海秘境。",
    highlights: [
      "东方奇幻美学与顶级视觉特效结合",
      "实景取景跨越四季山河",
      "动作设计融合传统武术与奇幻想象",
    ],
    tags: ["奇幻", "冒险", "东方美学", "动作"],
    releaseDate: "2022-08-12",
  },
  {
    id: "zuihou-ditie",
    title: "最后一班地铁",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20key%20art%20of%20a%20weary%20commuter%20alone%20on%20an%20empty%20subway%20platform%20at%20night%2C%20muted%20indigo%20and%20warm%20amber%20palette%2C%20quiet%20melancholic%20mood%2C%20soft%20fluorescent%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20festival%20film%20artwork&width=600&height=800&seq=film-cover-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20image%20of%20an%20empty%20subway%20platform%20at%20night%20with%20warm%20amber%20light%20spilling%20along%20the%20tracks%2C%20muted%20indigo%20and%20gray%20tones%2C%20quiet%20melancholic%20urban%20mood%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=1600&height=900&seq=film-bd-05&orientation=landscape",
    category: "电影",
    genres: ["剧情", "家庭", "都市"],
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    popularity: 6720,
    director: "陆知远",
    actors: ["马建国", "宋慧", "周小舟"],
    summary:
      "一位即将退休的地铁司机，在值乘最后一班列车的那个夜晚，遇见了三十年前刚刚来到这座城市的自己。两代人的对话，串起一座城市的变迁。",
    highlights: [
      "一镜到底的车厢长镜头，极具沉浸感",
      "以小切口讲述大时代的城市记忆",
      "自然细腻的表演被誉为年度惊喜",
    ],
    tags: ["剧情", "都市", "人文", "温情"],
    releaseDate: "2023-09-15",
  },
  {
    id: "miwu-zhuixiong",
    title: "迷雾追凶",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20key%20art%20of%20a%20detective%20silhouette%20before%20a%20fog%20covered%20harbor%20at%20dawn%2C%20cold%20steel%20blue%20and%20slate%20gray%20palette%20with%20a%20sharp%20orange%20accent%2C%20tense%20atmospheric%20lighting%2C%20minimal%20dramatic%20composition%2C%20no%20text%2C%20premium%20crime%20film%20artwork&width=600&height=800&seq=film-cover-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20fog%20covered%20harbor%20at%20dawn%20with%20steel%20blue%20water%20and%20industrial%20silhouettes%2C%20cold%20slate%20gray%20tones%20with%20a%20warm%20orange%20light%20break%2C%20tense%20crime%20drama%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-06&orientation=landscape",
    category: "电影",
    genres: ["犯罪", "悬疑", "剧情"],
    region: "中国香港",
    year: 2024,
    rating: 8.3,
    popularity: 8140,
    director: "黄伟然",
    actors: ["陈国栋", "严凯", "黎嘉欣"],
    summary:
      "一桩尘封多年的港岛旧案被重新翻出，退休警探与年轻记者组成临时搭档。真相像港口清晨的雾一样，越靠近越看不清。",
    highlights: [
      "港式犯罪片气质，节奏凌厉",
      "双时间线交叉推进，悬念层层递进",
      "群像刻画真实，人性灰度十足",
    ],
    tags: ["犯罪", "悬疑", "港片", "推理"],
    releaseDate: "2024-04-05",
  },
  {
    id: "changan-jioumeng",
    title: "长安旧梦",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20poster%20key%20art%20of%20an%20ancient%20Chinese%20palace%20rooftop%20at%20dusk%20with%20lanterns%20and%20falling%20snow%2C%20deep%20crimson%20gold%20and%20ink%20blue%20palette%2C%20elegant%20ornate%20atmosphere%2C%20dramatic%20rim%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20epic%20artwork&width=600&height=800&seq=film-cover-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20image%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%20with%20warm%20lanterns%20and%20gently%20falling%20snow%2C%20deep%20crimson%20gold%20and%20ink%20blue%20tones%2C%20elegant%20epic%20historical%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-07&orientation=landscape",
    category: "国产剧",
    genres: ["古装", "历史", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 9.0,
    popularity: 9560,
    director: "郑怀安",
    actors: ["顾清辞", "萧承煜", "温如卿"],
    summary:
      "乱世长安，一位出身寒门的女官凭借过人的才智在朝堂与市井之间周旋，她既要守护家国，也要面对隐藏在旧梦深处的身世之谜。",
    highlights: [
      "考究的服化道还原盛唐气象",
      "权谋线与情感线交织，节奏张弛有度",
      "长镜头群戏调度令人称道",
    ],
    tags: ["古装", "权谋", "历史", "女性成长"],
    releaseDate: "2023-10-20",
  },
  {
    id: "dongjing-shiguang",
    title: "东京食光",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20life%20drama%20poster%20key%20art%20of%20a%20cozy%20tiny%20tokyo%20ramen%20shop%20at%20night%20with%20warm%20glowing%20lanterns%2C%20warm%20amber%20and%20soft%20wood%20brown%20palette%20with%20gentle%20rain%2C%20intimate%20healing%20mood%2C%20soft%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20drama%20artwork&width=600&height=800&seq=film-cover-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20image%20of%20a%20cozy%20narrow%20tokyo%20alley%20at%20night%20with%20warm%20glowing%20lanterns%20and%20a%20small%20ramen%20shop%2C%20warm%20amber%20and%20soft%20brown%20tones%20with%20rainy%20bokeh%2C%20intimate%20healing%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-08&orientation=landscape",
    category: "海外剧",
    genres: ["生活", "美食", "温情"],
    region: "日本",
    year: 2024,
    rating: 8.7,
    popularity: 7020,
    director: "佐藤健一",
    actors: ["山田凉子", "中村翔太", "小林千夏"],
    summary:
      "东京小巷尽头有一家只在深夜营业的食堂，老板用一碗碗家常料理，接住每一位深夜来访者疲惫的心事。",
    highlights: [
      "每集一道治愈料理，画面温暖细腻",
      "单元剧结构，独立成篇又彼此呼应",
      "深夜城市氛围感十足",
    ],
    tags: ["治愈", "美食", "日剧", "温情"],
    releaseDate: "2024-01-12",
  },
  {
    id: "chengshi-zhiguang",
    title: "城市之光",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20key%20art%20of%20a%20young%20professional%20standing%20before%20a%20towering%20glass%20skyscraper%20at%20blue%20hour%2C%20cool%20indigo%20and%20city%20window%20amber%20palette%2C%20aspirational%20energetic%20mood%2C%20crisp%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20modern%20drama%20artwork&width=600&height=800&seq=film-cover-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20city%20skyline%20at%20blue%20hour%20with%20thousands%20of%20glowing%20windows%20in%20tall%20glass%20towers%2C%20cool%20indigo%20and%20warm%20amber%20light%20tones%2C%20aspirational%20modern%20urban%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-09&orientation=landscape",
    category: "电视剧",
    genres: ["都市", "职场", "情感"],
    region: "中国大陆",
    year: 2024,
    rating: 8.0,
    popularity: 7310,
    director: "吴念真",
    actors: ["程亦航", "王思睿", "李牧"],
    summary:
      "四个来自不同背景的年轻人合租在一间老城公寓，在理想与现实之间跌撞前行。他们的故事，就是这座城市的一束光。",
    highlights: [
      "真实还原年轻人在大城市的打拼状态",
      "群像叙事，友情线与事业线并重",
      "台词贴近生活，金句频出",
    ],
    tags: ["都市", "职场", "友情", "成长"],
    releaseDate: "2024-05-09",
  },
  {
    id: "anye-xingzhe",
    title: "暗夜行者",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20series%20poster%20key%20art%20of%20a%20hooded%20figure%20walking%20down%20a%20narrow%20wet%20alley%20lit%20by%20a%20single%20flickering%20lamp%2C%20deep%20charcoal%20and%20dark%20teal%20palette%20with%20a%20red%20accent%2C%20tense%20mysterious%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20thriller%20artwork&width=600&height=800&seq=film-cover-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20image%20of%20a%20narrow%20wet%20alley%20at%20night%20lit%20by%20flickering%20lamps%20with%20deep%20shadows%2C%20dark%20charcoal%20and%20teal%20tones%20with%20a%20faint%20red%20accent%2C%20tense%20suspenseful%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-10&orientation=landscape",
    category: "国产剧",
    genres: ["悬疑", "犯罪", "谍战"],
    region: "中国大陆",
    year: 2023,
    rating: 8.5,
    popularity: 8470,
    director: "韩夜",
    actors: ["江寒", "许龄月", "邵北"],
    summary:
      "白天他是温和的档案管理员，夜里他是游走于黑白之间的匿名线人。当一份足以颠覆地下秩序的名册出现，他必须做出选择。",
    highlights: [
      "强节奏与高信息密度，烧脑但不劝退",
      "双面人设张力十足",
      "光影风格突出，夜戏氛围极佳",
    ],
    tags: ["悬疑", "谍战", "烧脑", "强情节"],
    releaseDate: "2023-12-01",
  },
  {
    id: "qingchun-jishi",
    title: "青春纪事",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20poster%20key%20art%20of%20a%20group%20of%20teenage%20friends%20cycling%20down%20a%20tree%20lined%20campus%20road%20in%20late%20afternoon%20sun%2C%20fresh%20green%20and%20warm%20golden%20palette%2C%20bright%20nostalgic%20mood%2C%20cheerful%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20series%20artwork&width=600&height=800&seq=film-cover-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20campus%20scene%20with%20a%20tree%20lined%20road%20in%20late%20afternoon%20golden%20sunlight%2C%20fresh%20green%20and%20warm%20gold%20tones%2C%20bright%20nostalgic%20youthful%20atmosphere%2C%20soft%20bokeh%2C%20no%20text&width=1600&height=900&seq=film-bd-11&orientation=landscape",
    category: "电视剧",
    genres: ["青春", "校园", "成长"],
    region: "中国大陆",
    year: 2022,
    rating: 7.9,
    popularity: 5210,
    director: "林向阳",
    actors: ["方一诺", "赵清和", "孟晓"],
    summary:
      "高三那一年，五个性格迥异的少年在同一个教室相遇。关于友谊、梦想和说不出口的喜欢，都被悄悄写进了这本青春纪事。",
    highlights: [
      "真实还原国内高中生活细节",
      "阳光明亮的影像风格，青春感满分",
      "原创配乐带来强烈共鸣",
    ],
    tags: ["青春", "校园", "成长", "友情"],
    releaseDate: "2022-07-08",
  },
  {
    id: "guntu",
    title: "归途",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20key%20art%20of%20an%20elderly%20father%20and%20adult%20son%20standing%20on%20a%20rural%20road%20at%20dusk%20with%20distant%20hills%2C%20warm%20ochre%20earth%20and%20soft%20amber%20palette%2C%20gentle%20emotional%20mood%2C%20warm%20natural%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20family%20drama%20artwork&width=600&height=800&seq=film-cover-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20rural%20Chinese%20countryside%20scene%20at%20dusk%20with%20rolling%20hills%20and%20a%20winding%20road%2C%20warm%20ochre%20earth%20and%20soft%20amber%20tones%2C%20gentle%20emotional%20nostalgic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-12&orientation=landscape",
    category: "国产剧",
    genres: ["家庭", "剧情", "现实主义"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    popularity: 6890,
    director: "贾平生",
    actors: ["高远山", "李秋兰", "高知远"],
    summary:
      "在外打拼多年的儿子回到北方乡村的老家，为了送别突然离世的父亲。在整理遗物的过程中，他重新认识了这个沉默却深沉的家。",
    highlights: [
      "朴实克制的影像语言，情感真挚",
      "关注乡土与代际关系议题",
      "非职业演员还原真实生活质感",
    ],
    tags: ["家庭", "现实主义", "乡土", "父子"],
    releaseDate: "2024-03-22",
  },
  {
    id: "beihai-guying",
    title: "北海孤影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Nordic%20mystery%20series%20poster%20key%20art%20of%20a%20lonely%20lighthouse%20on%20a%20stormy%20northern%20sea%20cliff%2C%20cold%20slate%20blue%20and%20misty%20gray%20palette%20with%20a%20faint%20amber%20beam%2C%20desolate%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20crime%20drama%20artwork&width=600&height=800&seq=film-cover-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20Nordic%20coastline%20with%20a%20lone%20lighthouse%20on%20stormy%20cliffs%20and%20raging%20sea%2C%20cold%20slate%20blue%20and%20misty%20gray%20tones%20with%20amber%20light%2C%20desolate%20moody%20drama%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-13&orientation=landscape",
    category: "海外剧",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "英国",
    year: 2023,
    rating: 8.6,
    popularity: 6120,
    director: "Arthur Vance",
    actors: ["Emma Rowley", "Jonas Pike", "Clara Bech"],
    summary:
      "北海孤岛上的一座废弃灯塔，见证了二十年前的一场失踪。当新任警长抵达这座只有百人的小镇，沉默的居民们开始不安。",
    highlights: [
      "北欧黑色风格，冷峻而克制",
      "自然环境成为叙事的一部分",
      "结局余韵悠长，值得回味",
    ],
    tags: ["悬疑", "英剧", "北欧风", "犯罪"],
    releaseDate: "2023-02-17",
  },
  {
    id: "bali-xiaojiuguan",
    title: "巴黎小酒馆",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Parisian%20romance%20film%20poster%20key%20art%20of%20a%20charming%20small%20bistro%20with%20warm%20lights%20and%20outdoor%20tables%20on%20a%20cobblestone%20street%2C%20warm%20terracotta%20and%20soft%20gold%20palette%20with%20evening%20blue%2C%20romantic%20charming%20mood%2C%20soft%20lighting%2C%20minimal%20composition%2C%20no%20text%2C%20premium%20foreign%20drama%20artwork&width=600&height=800&seq=film-cover-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20Parisian%20cobblestone%20street%20at%20evening%20with%20a%20cozy%20bistro%20and%20warm%20glowing%20signs%2C%20warm%20terracotta%20and%20soft%20gold%20tones%20with%20evening%20blue%2C%20romantic%20charming%20atmosphere%2C%20no%20text&width=1600&height=900&seq=film-bd-14&orientation=landscape",
    category: "海外剧",
    genres: ["爱情", "剧情", "喜剧"],
    region: "法国",
    year: 2024,
    rating: 8.2,
    popularity: 5730,
    director: "Céline Moreau",
    actors: ["Sophie Laurent", "Marc Dubois", "Amélie Roux"],
    summary:
      "塞纳河畔的一间小酒馆，是无数故事开始的起点。老板娘、常客与旅人们在这里相遇、告别，也在这里学会与生活和解。",
    highlights: [
      "法式浪漫与生活哲学交织",
      "每集围绕一组客人展开，温暖动人",
      "巴黎街景与美食画面极具治愈力",
    ],
    tags: ["法剧", "爱情", "治愈", "生活"],
    releaseDate: "2024-02-14",
  },
];